var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 959,
    viewBox: "0 0 1440 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_598_908)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    filter: "url(#filter0_f_598_908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1558 68.4376C165.65 79.6999 137.087 165.645 196.217 196.258C245.465 221.753 329.948 190.457 378.373 216.614C430.281 244.652 463.207 292.251 454.65 335.853C446.08 379.522 396.004 420.463 334.738 438.95C277.153 456.327 210.146 417.071 148.987 428.091C89.5566 438.799 64.1606 506.068 3.56993 498.623C-54.4705 491.492 -54.8047 434.28 -81.1706 399.812C-100.637 374.364 -127.944 351.153 -130.939 322.781C-133.82 295.486 -110.471 271.396 -97.4694 245.383C-82.5477 215.529 -76.5035 184.429 -48.9225 158.692C-10.4053 122.751 26.7026 58.4076 92.1558 68.4376Z",
    fill: "#F8F000"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_598_908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.903 866.474C1000.02 940.005 869.235 972.842 853.386 1046.66C840.187 1108.13 920.662 1162.57 906.188 1223.76C890.673 1289.35 839.859 1351.23 776.143 1373.21C712.327 1395.22 633.857 1378.17 581.281 1335.83C531.864 1296.03 556.1 1209.28 513.834 1161.96C472.762 1115.97 369.054 1138.95 352.416 1079.58C336.478 1022.71 414.956 983.507 450.634 936.439C476.975 901.688 496.763 861.43 534.427 839.455C570.662 818.313 614.123 822.86 655.638 816.827C703.283 809.902 748.704 794.173 796.305 801.394C862.78 811.479 967.662 800.989 982.903 866.474Z",
    fill: "#F8F000"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_598_908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1677.88 369.943C1694.99 443.473 1564.21 476.31 1548.36 550.124C1535.16 611.599 1615.63 666.042 1601.16 727.23C1585.65 792.82 1534.83 854.697 1471.12 876.674C1407.3 898.685 1328.83 881.639 1276.25 839.298C1226.84 799.5 1251.07 712.749 1208.81 665.425C1167.74 619.439 1064.03 642.415 1047.39 583.046C1031.45 526.176 1109.93 486.975 1145.61 439.907C1171.95 405.156 1191.74 364.899 1229.4 342.923C1265.63 321.782 1309.1 326.329 1350.61 320.295C1398.26 313.371 1443.68 297.642 1491.28 304.863C1557.75 314.947 1662.64 304.457 1677.88 369.943Z",
    fill: "#F8F000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_598_908",
    x: -331.183,
    y: -132.611,
    width: 987.183,
    height: 831.808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_598_908"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_598_908",
    x: 150.307,
    y: 599.541,
    width: 1034.14,
    height: 983.302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_598_908"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_598_908",
    x: 845.279,
    y: 103.009,
    width: 1034.14,
    height: 983.302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_598_908"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_598_908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 959,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.cce936eb8266ee1fa1d4aea7c0a85e26.svg";
export { ForwardRef as ReactComponent };